// @ts-check

/**@type {ThemeHideSections}*/
const hide = {
  Solicitudes: {
    pendientes_validacion: false,
  },
}

export default hide
